<template>
  <svg
    :class="customStyle"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="20"
      cy="20.5"
      r="20"
      fill="white"
    />
    <path
      d="M14.0555 15.7728C14.0555 15.0753 14.8027 14.6337 15.4138 14.9694L24.8168 20.141C24.9607 20.2201 25.0808 20.3364 25.1644 20.4777C25.248 20.619 25.2921 20.7802 25.2921 20.9444C25.2921 21.1086 25.248 21.2698 25.1644 21.4112C25.0808 21.5525 24.9607 21.6688 24.8168 21.7478L15.4138 26.9195C15.2742 26.9962 15.1171 27.0353 14.9578 27.0327C14.7985 27.0302 14.6426 26.9863 14.5055 26.9052C14.3684 26.8241 14.2548 26.7087 14.1759 26.5703C14.097 26.4319 14.0555 26.2754 14.0555 26.1161V15.7728Z"
      fill="#218579"
      stroke="#218579"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'PlayIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
